/* global $ */

$(document).on('click','[data-instagram]',function(){
  var postdata = $(this).data('post');

  $.fancybox.open( $(this), {
    animationEffect: "zoom",
    baseClass: "instagram",
    toolbar: false,
    smallBtn: false,
    type: 'ajax',
    ajax : {
      settings: {
        type: 'POST',
        data: {
          postdata: postdata
        }
      }
    },
    touch: false,
    afterShow: function(instance) {
      var carousel = $(instance.current.$content).find(".carousel");
      if(carousel.length) {
        carousel.slick({
          arrows: true,
          dots: false,
          responsive: [
            {
              breakpoint: 600,
              settings: {
                arrows: false,
                dots: true
              }
            }
          ]
        });
      }
    }
  });
});